import { graphql } from "../../../../generated/gql";

export const COMPOSE_LAYOUT = graphql(`
  mutation composeLayout($input: ComposeLayoutInput!) {
    composeLayout(input: $input) {
      success
      presentationRenderingUrl
      presentationRenderingMimeType
      backgroundRenderingUrl
      backgroundRenderingMimeType
      composedImage {
        data
        mimeType
      }
      composedImageAI {
        data
        mimeType
      }
    }
  }
`);
